import { render, staticRenderFns } from "./requisites.vue?vue&type=template&id=4a71aa43&scoped=true&"
import script from "./requisites.vue?vue&type=script&lang=js&"
export * from "./requisites.vue?vue&type=script&lang=js&"
import style0 from "./requisites.vue?vue&type=style&index=0&id=4a71aa43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a71aa43",
  null
  
)

export default component.exports